export default {
  END_TRANSACTION: "END_TRANSACTION",
  INCREMENT_COUNTER: "INCREMENT_COUNTER",
  DECREMENT_COUNTER: "DECREMENT_COUNTER",
  INCREMENT_COUNTER_DOUBLE: "INCREMENT_COUNTER_DOUBLE",
  DECREMENT_COUNTER_DOUBLE: "DECREMENT_COUNTER_DOUBLE",
  API_ERRORED: "API_ERRORED",
  SET_COUNTER: "SET_COUNTER",
  START_REQUEST: "START_REQUEST",
  END_REQUEST: "END_REQUEST",
  LOGIN_USER: "LOGIN_USER",
  LOGIN_TUTOR: "LOGIN_TUTOR",
  LOGOUT: "LOGOUT",
  LOGOUT_TUTOR: "LOGOUT_TUTOR",
  REMOVEUSER: "REMOVEUSER",
  LOGIN_DATA: "LOGIN_DATA",
  LOGIN_ERROR: "LOGIN_ERROR",
  GET_TUTORS: "GET_TUTORS",
  ACTIVATE_COUNSELOR_BY_TOKEN: "ACTIVATE_COUNSELOR_BY_TOKEN",
  ACTIVATE_COUNSELOR_BY_TOKEN_DONE: "ACTIVATE_COUNSELOR_BY_TOKEN_DONE",
  ACTIVATE_COUNSELOR_BY_TOKEN_ERROR: "ACTIVATE_COUNSELOR_BY_TOKEN_ERROR",
  ACTIVATE_TUTOR_BY_ID: "ACTIVATE_TUTOR_BY_ID",
  TUTOR_VALIDATED: "TUTOR_VALIDATED",
  TUTOR_VALIDATED_ERROR: "TUTOR_VALIDATED_ERROR",
  TUTORS_RETRIEVED: "TUTORS_RETRIEVED",
  TUTORS_RETRIEVED_ERROR: "TUTORS_RETRIEVED_ERROR",
  FORGOTPASSWORD: "FORGOTPASSWORD",
  TUTOR_FORGOTPASSWORD: "TUTOR_FORGOTPASSWORD",
  FORGOTPASSWORD_DATA: "FORGOTPASSWORD_DATA",
  TUTOR_FORGOTPASSWORD_DATA: "FORGOTPASSWORD_DATA",
  FORGOTPASSWORD_ERROR: "FORGOTPASSWORD_ERROR",
  TUTOR_FORGOTPASSWORD_ERROR: "FORGOTPASSWORD_ERROR",
  RESETPASSWORD: "RESETPASSWORD",
  RESETPASSWORD_DATA: "RESETPASSWORD_DATA",
  RESETPASSWORD_ERROR: "RESETPASSWORD_ERROR",

  GET_COUNTRIES: "GET_COUNTRIES",
  GET_COUNTRIES_DATA: "GET_COUNTRIES_DATA",
  GET_COUNTRIES_ERROR: "GET_COUNTRIES_ERROR",

  GET_PROVINCES: "GET_PROVINCES",
  GET_PROVINCESCOUNTRY: "GET_PROVINCESCOUNTRY",
  GET_PROVINCES_DATA: "GET_PROVINCES_DATA",
  GET_PROVINCES_ERROR: "GET_PROVINCES_ERROR",

  GET_CITIES: "GET_CITIES",
  GET_CITIES_DATA: "GET_CITIES_DATA",
  GET_CITIES_ERROR: "GET_CITIES_ERROR",

  GET_COURSES: "GET_COURSES",
  GET_COURSES_DATA: "GET_COURSES_DATA",
  GET_COURSES_ERROR: "GET_COURSES_ERROR",

  GET_PROFESSIONS: "GET_PROFESSIONS",
  GET_PROFESSIONS_DATA: "GET_PROFESSIONS_DATA",
  GET_PROFESSIONS_ERROR: "GET_PROFESSIONS_ERROR",

  REGISTER_USER: "REGISTER_USER",
  REGISTER_USER_DATA: "REGISTER_USER_DATA",
  REGISTER_USER_ERROR: "REGISTER_USER_ERROR",
  REGISTER_TUTOR: "REGISTER_TUTOR",
  REGISTER_TUTOR_DATA: "REGISTER_TUTOR_DATA",
  REGISTER_TUTOR_ERROR: "REGISTER_TUTOR_ERROR",
  CLEAN_REGISTER_USER: "CLEAN_REGISTER_USER",

  GET_QUESTIONNAIRE: "GET_QUESTIONNAIRE",
  GET_QUESTIONNAIRE_DATA: "GET_QUESTIONNAIRE_DATA",
  GET_QUESTIONNAIRE_ERROR: "GET_QUESTIONNAIRE_ERROR",

  GET_QUESTIONNAIRES: "GET_QUESTIONNAIRES",
  GET_QUESTIONNAIRES_DATA: "GET_QUESTIONNAIRES_DATA",
  GET_QUESTIONNAIRES_ERROR: "GET_QUESTIONNAIRES_ERROR",

  GET_ASSESSMENTS: "GET_ASSESSMENTS",
  GET_ASSESSMENTS_DATA: "GET_ASSESSMENTS_DATA",
  GET_ASSESSMENTS_ERROR: "GET_ASSESSMENTS_ERROR",

  CHECK_CODE: "CHECK_CODE",
  CHECK_CODE_DATA: "CHECK_CODE_DATA",
  CHECK_CODE_ERROR: "CHECK_CODE_ERROR",
  CLEAN_CHECK_CODE: "CLEAN_CHECK_CODE",

  GET_ASSESSMENTS_CODE: "GET_ASSESSMENTS_CODE",
  GET_ASSESSMENTS_CODE_DATA: "GET_ASSESSMENTS_CODE_DATA",
  GET_ASSESSMENTS_CODE_ERROR: "GET_ASSESSMENTS_CODE_ERROR",

  SAVE_ANSWER: "SAVE_ANSWER",
  SAVE_ANSWER_DATA: "SAVE_ANSWER_DATA",
  SAVE_ANSWER_ERROR: "SAVE_ANSWER_ERROR",
  CLEAR_ANSWER: "CLEAR_ANSWER",
  GET_ANSWERS_DATA: "GET_ANSWERS_DATA",
  GET_ANSWERS_DATA_V2: "GET_ANSWERS_DATA_V2",
  GET_ANSWERS_ERROR: "GET_ANSWERS_ERROR",
  GET_ANSWERS: "GET_ANSWERS",
  GET_ANSWERS_V2: "GET_ANSWERS_V2",

  SAVE_AREA: "SAVE_AREA",
  SAVE_AREA_DATA: "SAVE_AREA_DATA",
  SAVE_AREA_ERROR: "SAVE_AREA_ERROR",
  CLEAR_SAVE_AREA: "CLEAR_SAVE_AREA",

  SAVE_NAME: "SAVE_NAME",
  SAVE_NAME_DATA: "SAVE_NAME_DATA",
  SAVE_NAME_ERROR: "SAVE_NAME_ERROR",

  REGISTER_CENTER: "REGISTER_CENTER",
  REGISTER_CENTER_DATA: "REGISTER_CENTER_DATA",
  REGISTER_CENTER_ERROR: "REGISTER_CENTER_ERROR",
  GET_USER_DATA: "GET_USER_DATA",
  GET_USER_ERROR: "GET_USER_ERROR",

  CLEAN_REGISTER_DATA: "CLEAN_REGISTER_DATA",

  INFO_CENTER: "INFO_CENTER",
  INFO_CENTER_DATA: "INFO_CENTER_DATA",
  INFO_CENTER_ERROR: "INFO_CENTER_ERROR",
  INFO_CENTER_CLEAR: "INFO_CENTER_CLEAR",

  GET_ITEMS: "GET_ITEMS",
  GET_ITEMS_DATA: "GET_ITEMS_DATA",
  GET_ITEMS_ERROR: "GET_ITEMS_ERROR",

  SAVE_ITEM: "SAVE_ITEM",
  SAVE_ITEM_DATA: "SAVE_ITEM_DATA",
  SAVE_ITEM_ERROR: "SAVE_ITEM_ERROR",
  CLEAR_SAVE_ITEM: "CLEAR_SAVE_ITEM",

  GET_AREA_STUDENT: "GET_AREA_STUDENT",
  GET_AREA_STUDENT_DATA: "GET_AREA_STUDENT_DATA",
  GET_AREA_STUDENT_ERROR: "GET_AREA_STUDENT_ERROR",

  GET_AVITEMS: "GET_AVITEMS",
  GET_AVITEMS_DATA: "GET_AVITEMS_DATA",
  GET_AVITEMS_ERROR: "GET_AVITEMS_ERROR",

  PDF_CENTER: "PDF_CENTER",
  PDF_CENTER_DATA: "PDF_CENTER_DATA",
  PDF_CENTER_ERROR: "PDF_CENTER_ERROR",
  PDF_CENTER_CLEAR: "PDF_CENTER_CLEAR",

  CLEAR_DATA_ANSWER: "CLEAR_DATA_ANSWER",
  DELETE_ANSWER: "DELETE_ANSWER",
  DELETE_ANSWER_DATA: "DELETE_ANSWER_DATA",
  CLEAR_DELETE_ANSWER_DATA: "CLEAR_DELETE_ANSWER_DATA",
  CLEAR_ASSESSMENTS_CODE: "CLEAR_ASSESSMENTS_CODE",
  GET_RESPONSES: "GET_RESPONSES",
  GET_RESPONSES_DATA: "GET_RESPONSES_DATA",
  GET_RESPONSE: "GET_RESPONSE",
  GET_RESPONSE_DATA: "GET_RESPONSE_DATA",

  GET_ACTUAL_YEAR: "GET_ACTUAL_YEAR",
  GET_ACTUAL_YEAR_DATA: "GET_ACTUAL_YEAR_DATA",
  GET_ACTUAL_YEAR_ERROR: "GET_ACTUAL_YEAR_ERROR",
};
